import * as catalogJson from "./runtime/catalog.json"
import { RuntimeCatalog } from "./schema"
import { createContentReleaseManifest } from "./release"
import { RuntimeContent } from "./runtime"

/** Stable browser-safe import. The tools compiler validates before publication. */
// Common and server use different interop settings; normalize both JSON module shapes.
const bundled = ((catalogJson as any).default || catalogJson) as RuntimeCatalog
export const contentRuntime = new RuntimeContent(createContentReleaseManifest(bundled.revision, Object.keys(bundled.assets)), bundled)
export let contentCatalog: RuntimeCatalog
export let contentRevision: string
export const contentGeneration = (): number => contentRuntime.active.generation
export const bindContent = <T>(select: (catalog: RuntimeCatalog) => T, apply: (state: T) => void): (() => void) => contentRuntime.bind(select, apply)
bindContent(catalog => ({ catalog, revision: catalog.revision }), state => {
    contentCatalog = state.catalog
    contentRevision = state.revision
})
export const hasItemId = (value: unknown): value is string => typeof value === "string" && contentCatalog.items.all.includes(value)
export const hasRaceId = (value: unknown): value is string => typeof value === "string" && contentCatalog.source.sprites.registration.RaceTypes.includes(value)
export const requireItemId = (value: unknown): string => {
    if (!hasItemId(value)) throw new Error(`Unknown saved or network item ID: ${String(value)}`)
    return value
}
export const requireContentRevision = (revision: string): void => {
    if (revision !== contentRevision) throw new Error(`Content revision mismatch: expected ${contentRevision}, received ${revision}`)
}
/** Generic open-catalog lookup; a new subclass requires no named export. */
export const itemTypesForSubclass = (subclass: string): readonly string[] => contentCatalog.items.subClasses[subclass] || []

/**
 * Keep resource keys stable ("assets/<logical name>") while fetching media from this immutable
 * release. Every game asset is registered content; an unregistered name is a bug, not a request
 * for some older location.
 */
export const contentAssetUrl = (url: string): string => {
    const prefix = "assets/"
    if (!url.startsWith(prefix) || url.startsWith(`${prefix}content/`)) return url
    const published = contentCatalog.assets[url.slice(prefix.length)]
    if (!published) throw new Error(`Unregistered content asset ${url}`)
    return prefix + published
}
